import React, { useReducer, useEffect } from 'react'
import {
  GET_MESSAGE_LIST,
  GET_MESSAGE_DETAIL,
  MessageItem,
  MessageDetailRes,
} from '../../api/orderManage'
import {
  getSupplierId,
  getUserId,
  isResponseCodeSuccess,
} from '../../tools/util'
import { jumpOrderDetail } from '../../modules/home/messagebox/hooks'

type ActionType =
  | 'setDateSource'
  | 'setPagination'
  | 'setIsTableLoading'
  | 'setSearchParam'
  | 'setCheckedRadioKey'
  | 'setVisible'
  | 'setRecord'
interface Action {
  type: ActionType
  payload: any
}

interface paginationOption {
  total: number
  current: number
  pagesize: number
}

export type RecordDetail = MessageDetailRes & {
  // type: '1' | '7'
  type: string
  title?: string
}
interface State {
  currentRadioDict: RadioDict
  checkedRadioKey: returnManagementTabKey // 当前选中tab的key值
  dateSource: MessageItem[]
  isTableLoading: boolean
  pagination: paginationOption
  searchParam: any
  confirmVisible: boolean
  record?: RecordDetail
}

export type returnManagementTabKey = '已读' | '未读' | '全部'

type RadioDict = {
  [x in returnManagementTabKey]: {
    key: string
    keyName: string
    value: string
    numMap: string
  }
}

const initialRadioDict: RadioDict = {
  全部: {
    key: 'all',
    value: '全部',
    keyName: '全部',
    numMap: '',
  },
  未读: {
    key: 'yidu',
    value: '未读',
    keyName: '未读',
    numMap: 'false',
  },
  已读: {
    key: 'weidu',
    value: '已读',
    keyName: '已读',
    numMap: 'true',
  },
}

const initialState: State = {
  currentRadioDict: initialRadioDict, // 当前tab列表的值
  checkedRadioKey: '全部', // 当前选中tab的key值
  dateSource: [],
  isTableLoading: false,
  pagination: {
    total: 20,
    current: 1,
    pagesize: 20,
  },
  searchParam: {},
  confirmVisible: false,
  record: undefined,
}

const reducer = (state: State, action: Action): State => {
  const newstate = { ...state }
  switch (action.type) {
    case 'setDateSource':
      newstate.dateSource = action.payload
      return newstate
    case 'setPagination':
      newstate.pagination = action.payload
      return newstate
    case 'setSearchParam':
      newstate.searchParam = action.payload
      return newstate
    case 'setIsTableLoading':
      newstate.isTableLoading = action.payload
      return newstate
    case 'setCheckedRadioKey':
      newstate.checkedRadioKey = action.payload
      return newstate
    case 'setVisible':
      newstate.confirmVisible = action.payload
      return newstate
    case 'setRecord':
      newstate.record = action.payload
      return newstate

    default:
      throw new Error('not match actions')
  }
}

/**
 * 用于暂时保存搜索条件对象，这样重置之前 点击下一页就会附带这个搜索条件
 * @param val 搜索条件对象
 * @returns
 */
const setSearchParam = (val: any): Action => ({
  type: 'setSearchParam',
  payload: val,
})

/**
 * 设置分页相关选项
 * @param param
 * @returns
 */
const setPagination = (val: paginationOption): Action => ({
  type: 'setPagination',
  payload: val,
})

/**
 * 设置数据
 * @param param
 * @returns
 */
const setDateSource = (val: MessageItem[]): Action => ({
  type: 'setDateSource',
  payload: val,
})

/**
 * 设置loding
 * @param param
 * @returns
 */
const setIsTableLoading = (val: boolean): Action => ({
  type: 'setIsTableLoading',
  payload: val,
})

/**
 * 设置loding
 * @param param
 * @returns
 */
const setVisible = (val: boolean): Action => ({
  type: 'setVisible',
  payload: val,
})

/**
 * 设置当前选中radio tab的key值
 * @param key
 * @returns
 */
const setCheckedRadioKey = (val: React.Key): Action => ({
  type: 'setCheckedRadioKey',
  payload: val,
})

/**
 * 设置当前选中radio tab的key值
 * @param key
 * @returns
 */
const setRecord = (val?: RecordDetail): Action => ({
  type: 'setRecord',
  payload: val,
})

export default function useHook() {
  const [state, dispatch] = useReducer(reducer, initialState)
  const {
    dateSource,
    isTableLoading,
    pagination,
    searchParam,
    currentRadioDict,
    checkedRadioKey,
    confirmVisible,
    record,
  } = state

  useEffect(() => {
    getMesList({
      pageSize: pagination.pagesize,
      pageNo: pagination.current,
    })
    // eslint-disable-next-line
  }, [pagination.current, pagination.pagesize, checkedRadioKey, searchParam])

  const getMesList = async (param: { pageSize?: number; pageNo?: number }) => {
    dispatch(setIsTableLoading(true))
    const { pageNo, pageSize } = param
    let readState = null
    if (currentRadioDict[checkedRadioKey].key === 'yidu') {
      readState = false
    } else if (currentRadioDict[checkedRadioKey].key === 'weidu') {
      readState = true
    }
    const data = {
      userId: getUserId(),
      supplierId: getSupplierId(),
      pageNo: pagination.current,
      pageSize: pagination.pagesize,
      ...searchParam,
      readState: readState,
    }
    const res = await GET_MESSAGE_LIST({ ...data })
    if (isResponseCodeSuccess(res.code)) {
      // 设置当前表格数据
      dispatch(setDateSource(res.data.content))
      // 设置当前页面数据量
      dispatch(
        setPagination({
          ...pagination,
          pagesize: pageSize ? pageSize : pagination.pagesize,
          current: pageNo ? pageNo : pagination.current,
          total: res.data.totalCount,
        }),
      )
      dispatch(setIsTableLoading(false))
    }
  }
  const handleSearchClick = (value: any) => {
    dispatch(setSearchParam(value))
  }
  const handlePaginationChange = (page: number, pageSize?: number) => {
    dispatch(
      setPagination({
        total: 20,
        pagesize: pageSize ? pageSize : pagination.pagesize,
        current: page,
      }),
    )
  }

  const handleCheckedChange = (key: any) => {
    dispatch(setCheckedRadioKey(key))
  }

  const onConfirmDeleteScheme = () => {
    dispatch(setVisible(false))
  }
  const openModal = async (record: MessageItem) => {
    const res = await GET_MESSAGE_DETAIL({ id: record.id })
    if (isResponseCodeSuccess(res.code)) {
      dispatch(setVisible(true))
      dispatch(
        setRecord({
          ...res.data,
          type: record.type,
        }),
      )
    }
  }
  // 跳转至详情页
  const jumpDetail = () => {
    jumpOrderDetail({
      type: record?.type ?? '',
      supplierOrderId: record?.supplierOrderId ?? '',
    })
    onConfirmDeleteScheme()
  }

  return {
    isTableLoading,
    dateSource,
    handleSearchClick,
    pagination,
    handlePaginationChange,
    currentRadioDict,
    handleCheckedChange,
    confirmVisible,
    onConfirmDeleteScheme,
    openModal,
    jumpDetail,
    record,
  }
}
import React, { useReducer, useEffect } from 'react'
import {
  GET_MESSAGE_LIST,
  GET_MESSAGE_DETAIL,
  MessageItem,
  MessageDetailRes,
} from '../../api/orderManage'
import {
  getSupplierId,
  getUserId,
  isResponseCodeSuccess,
} from '../../tools/util'
import { jumpOrderDetail } from '../../modules/home/messagebox/hooks'

type ActionType =
  | 'setDateSource'
  | 'setPagination'
  | 'setIsTableLoading'
  | 'setSearchParam'
  | 'setCheckedRadioKey'
  | 'setVisible'
  | 'setRecord'
interface Action {
  type: ActionType
  payload: any
}

interface paginationOption {
  total: number
  current: number
  pagesize: number
}

export type RecordDetail = MessageDetailRes & {
  // type: '1' | '7'
  type: string
  title?: string
}
interface State {
  currentRadioDict: RadioDict
  checkedRadioKey: returnManagementTabKey // 当前选中tab的key值
  dateSource: MessageItem[]
  isTableLoading: boolean
  pagination: paginationOption
  searchParam: any
  confirmVisible: boolean
  record?: RecordDetail
}

export type returnManagementTabKey = '已读' | '未读' | '全部'

type RadioDict = {
  [x in returnManagementTabKey]: {
    key: string
    keyName: string
    value: string
    numMap: string
  }
}

const initialRadioDict: RadioDict = {
  全部: {
    key: 'all',
    value: '全部',
    keyName: '全部',
    numMap: '',
  },
  未读: {
    key: 'yidu',
    value: '未读',
    keyName: '未读',
    numMap: 'false',
  },
  已读: {
    key: 'weidu',
    value: '已读',
    keyName: '已读',
    numMap: 'true',
  },
}

const initialState: State = {
  currentRadioDict: initialRadioDict, // 当前tab列表的值
  checkedRadioKey: '全部', // 当前选中tab的key值
  dateSource: [],
  isTableLoading: false,
  pagination: {
    total: 20,
    current: 1,
    pagesize: 20,
  },
  searchParam: {},
  confirmVisible: false,
  record: undefined,
}

const reducer = (state: State, action: Action): State => {
  const newstate = { ...state }
  switch (action.type) {
    case 'setDateSource':
      newstate.dateSource = action.payload
      return newstate
    case 'setPagination':
      newstate.pagination = action.payload
      return newstate
    case 'setSearchParam':
      newstate.searchParam = action.payload
      return newstate
    case 'setIsTableLoading':
      newstate.isTableLoading = action.payload
      return newstate
    case 'setCheckedRadioKey':
      newstate.checkedRadioKey = action.payload
      return newstate
    case 'setVisible':
      newstate.confirmVisible = action.payload
      return newstate
    case 'setRecord':
      newstate.record = action.payload
      return newstate

    default:
      throw new Error('not match actions')
  }
}

/**
 * 用于暂时保存搜索条件对象，这样重置之前 点击下一页就会附带这个搜索条件
 * @param val 搜索条件对象
 * @returns
 */
const setSearchParam = (val: any): Action => ({
  type: 'setSearchParam',
  payload: val,
})

/**
 * 设置分页相关选项
 * @param param
 * @returns
 */
const setPagination = (val: paginationOption): Action => ({
  type: 'setPagination',
  payload: val,
})

/**
 * 设置数据
 * @param param
 * @returns
 */
const setDateSource = (val: MessageItem[]): Action => ({
  type: 'setDateSource',
  payload: val,
})

/**
 * 设置loding
 * @param param
 * @returns
 */
const setIsTableLoading = (val: boolean): Action => ({
  type: 'setIsTableLoading',
  payload: val,
})

/**
 * 设置loding
 * @param param
 * @returns
 */
const setVisible = (val: boolean): Action => ({
  type: 'setVisible',
  payload: val,
})

/**
 * 设置当前选中radio tab的key值
 * @param key
 * @returns
 */
const setCheckedRadioKey = (val: React.Key): Action => ({
  type: 'setCheckedRadioKey',
  payload: val,
})

/**
 * 设置当前选中radio tab的key值
 * @param key
 * @returns
 */
const setRecord = (val?: RecordDetail): Action => ({
  type: 'setRecord',
  payload: val,
})

export default function useHook() {
  const [state, dispatch] = useReducer(reducer, initialState)
  const {
    dateSource,
    isTableLoading,
    pagination,
    searchParam,
    currentRadioDict,
    checkedRadioKey,
    confirmVisible,
    record,
  } = state

  useEffect(() => {
    getMesList({
      pageSize: pagination.pagesize,
      pageNo: pagination.current,
    })
    // eslint-disable-next-line
  }, [pagination.current, pagination.pagesize, checkedRadioKey, searchParam])

  const getMesList = async (param: { pageSize?: number; pageNo?: number }) => {
    dispatch(setIsTableLoading(true))
    const { pageNo, pageSize } = param
    let readState = null
    if (currentRadioDict[checkedRadioKey].key === 'yidu') {
      readState = false
    } else if (currentRadioDict[checkedRadioKey].key === 'weidu') {
      readState = true
    }
    const data = {
      userId: getUserId(),
      supplierId: getSupplierId(),
      pageNo: pagination.current,
      pageSize: pagination.pagesize,
      ...searchParam,
      readState: readState,
    }
    const res = await GET_MESSAGE_LIST({ ...data })
    if (isResponseCodeSuccess(res.code)) {
      // 设置当前表格数据
      dispatch(setDateSource(res.data.content))
      // 设置当前页面数据量
      dispatch(
        setPagination({
          ...pagination,
          pagesize: pageSize ? pageSize : pagination.pagesize,
          current: pageNo ? pageNo : pagination.current,
          total: res.data.totalCount,
        }),
      )
      dispatch(setIsTableLoading(false))
    }
  }
  const handleSearchClick = (value: any) => {
    dispatch(setSearchParam(value))
  }
  const handlePaginationChange = (page: number, pageSize?: number) => {
    dispatch(
      setPagination({
        total: 20,
        pagesize: pageSize ? pageSize : pagination.pagesize,
        current: page,
      }),
    )
  }

  const handleCheckedChange = (key: any) => {
    dispatch(setCheckedRadioKey(key))
  }

  const onConfirmDeleteScheme = () => {
    dispatch(setVisible(false))
  }
  const openModal = async (record: MessageItem) => {
    const res = await GET_MESSAGE_DETAIL({ id: record.id })
    if (isResponseCodeSuccess(res.code)) {
      dispatch(setVisible(true))
      dispatch(
        setRecord({
          ...res.data,
          type: record.type,
        }),
      )
    }
  }
  // 跳转至详情页
  const jumpDetail = () => {
    jumpOrderDetail({
      type: record?.type ?? '',
      supplierOrderId: record?.supplierOrderId ?? '',
    })
    onConfirmDeleteScheme()
  }

  return {
    isTableLoading,
    dateSource,
    handleSearchClick,
    pagination,
    handlePaginationChange,
    currentRadioDict,
    handleCheckedChange,
    confirmVisible,
    onConfirmDeleteScheme,
    openModal,
    jumpDetail,
    record,
  }
}
